import { Link } from '../lib/router';
import { minutes } from '../lib/format';
import type { ContinueItem, Show } from '../lib/types';
import { PosterArt, PosterLink } from './Poster';

export function RailHeader({ title, subtitle, to }: { title: string; subtitle?: string; to?: string }) {
  return (
    <div className="rail-head">
      <div>
        <h2 className="rail-title">{title}</h2>
        {subtitle && <p className="rail-sub">{subtitle}</p>}
      </div>
      {to && <Link to={to} className="text-link">See all</Link>}
    </div>
  );
}

export function Rail({ title, subtitle, items, to }: { title: string; subtitle?: string; items: Show[]; to?: string }) {
  return (
    <section className="rail">
      <RailHeader title={title} subtitle={subtitle} to={to} />
      <div className="rail-row">
        {items.map((s) => <PosterLink key={s.id} show={s} />)}
      </div>
    </section>
  );
}

export function Top10Rail({ title, subtitle, items }: { title: string; subtitle?: string; items: Show[] }) {
  return (
    <section className="rail">
      <RailHeader title={title} subtitle={subtitle} />
      <ol className="rail-row top10">
        {items.slice(0, 10).map((s, i) => (
          <li key={s.id}>
            <Link to={`/show/${s.slug}`} className="top10-item">
              <span className="top10-num" aria-hidden="true">{i + 1}</span>
              <PosterArt show={s} size="sm" rank={i + 1} />
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}

export function ContinueRail({ items }: { items: ContinueItem[] }) {
  return (
    <section className="rail">
      <RailHeader title="Continue watching" />
      <div className="rail-row">
        {items.map(({ show, episode, positionS }) => (
          <Link key={episode.id} to={`/watch/${show.id}/${episode.no}`} className="poster-link">
            <PosterArt show={show} progress={positionS / episode.durationS} />
            <span className="poster-meta">Ep {episode.no} · {minutes(episode.durationS - positionS)} left</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
